export default {"src":"https://assets.ctr1.net/d1a32bdc1f09/_next/static/media/pingone.153c8888.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};